import type { SVGProps } from 'react';

const SvgFileUpload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M5 10h4v6h6v-6h4l-7-7zm0 8v2h14v-2z" />
  </svg>
);
export default SvgFileUpload;
